import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";

interface ErrorDisplayProps {
  error: Error | null;
  className?: string;
}

// Extend Error to include cause property
interface ExtendedError extends Error {
  cause?: unknown;
}

const ErrorDisplay = ({ error, className }: ErrorDisplayProps) => {
  if (!error) return null;

  // Cast to ExtendedError to access cause property
  const extendedError = error as ExtendedError;

  // Log the full error details to console for debugging
  console.error('Detailed error information:', {
    message: error.message,
    stack: error.stack,
    name: error.name,
    cause: extendedError.cause,
  });

  return (
    <Alert variant="destructive" className={className}>
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Error</AlertTitle>
      <AlertDescription className="mt-2">
        <div className="text-sm">
          {error.message}
        </div>
        {extendedError.cause && (
          <div className="mt-2 text-xs opacity-80">
            Additional details: {JSON.stringify(extendedError.cause)}
          </div>
        )}
      </AlertDescription>
    </Alert>
  );
};

export default ErrorDisplay;